<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="290"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Login
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="username"
            append-icon="mdi-user"
            type="text"
            name="username"
            label="User name"
          ></v-text-field>
          <v-text-field
            v-model="password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            name="password"
            label="Password"
            counter
            @click:append="showPassword = !showPassword"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="cancel"
          >
            Cancel
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="login"
          >
            Login
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: 'AuthLogin',

  components: {
  },

  computed: mapGetters(['getLoggedIn']),

  methods: {
    ...mapActions(['fetchAuthLogin', 'fetchAuthLogout', 'fetchSetCookie']),
    login() {
      this.fetchAuthLogin({username: this.username, password: this.password})
      if (this.$route.query.from != null)
        this.$router.push({ path: this.$route.query.from}).catch(error => {
          this.$router.push({ name: 'Home' })
        })
      else
        this.$router.push({ name: 'Home' })
    },
    cancel() {
      this.dialog = false
      this.$router.push({ name: 'Home' })
    },
  },

  mounted() {
    this.dialog = true
    this.username = null
    this.password = null
  },

  data() {
    return {
      dialog: true,
      showPassword: false,
      username: null,
      password: null,
    }
  },
}
</script>

<style scoped lang="scss">
</style>
